import { useSelector } from 'react-redux';
import { selectUserHasIterableEmail } from 'core/userContext';
import { selectEnabledPreviews } from 'modules/app/selectors';

export const useAllowPreview = (previewKey: string) => {
  const enabledPreviews = useSelector(selectEnabledPreviews);
  const hasIterableEmail = useSelector(selectUserHasIterableEmail);
  return enabledPreviews?.includes(previewKey) && hasIterableEmail;
};
